module.exports = __webpack_public_path__ + "static/ActaDeck-Book-a10893acb029220e1bc7ee039ac9e826.woff";